<div class="auth-email-field">
  <div
    class="auth-email-field__container"
    [class.auth-email-field__container--error]="showError"
  >
    <img
      src="assets/icons/email.svg"
      alt=""
      class="auth-email-field__icon"
      aria-hidden="true"
    />
    <input
      type="email"
      class="auth-email-field__input"
      [placeholder]="placeholder"
      [formControl]="control"
      autocomplete="email"
    />
  </div>
  <div
    *ngIf="showError"
    class="auth-email-field__hint"
    [class.auth-email-field__hint--compact]="compactErrorSpacing"
  >
    {{ invalidHint }}
  </div>
</div>
